export default __webpack_public_path__ + "static/media/Export.03aa70f8.PNG";